// extracted by mini-css-extract-plugin
export default {"card":"card__xYs8duxT","cardHeader":"card-header__nJrlNDTb","cardBody":"card-body__OOtquXrW"};